import { PersistConfig } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';

import { AuthState } from './types';

export const authPersistConfig: PersistConfig<AuthState> = {
  key: 'auth',
  storage: sessionStorage,
  whitelist: ['authenticationKey', 'codeVerifier'],
};
